export default __webpack_public_path__ + "static/media/origami-bird-green.3803f839.png";